import React, { useState, useEffect } from 'react'
import BarChart from '../../../Calado/components/BarChart'
import ReporteProductosCalado from '../../../ReporteCamiones/containers/reportes/ReporteProductosCalado'
import UltimaActualizacionData from '../../../Utils/containers/UltimaActualizacionDatos'
import { INTERVALO_ACTUALIZACION } from '../../../../config/settings'

export default function EstadoPlayaCalado (props) {
  const { data, camionesCalados, calificacionCalle, callesDeCalado, ocupacionCalles, actualizado, setActualizado, actualizarPlayaCalado } = props
  const [ultimaActualizacion, setUltimaActualizacion] = useState(new Date())

  useEffect(() => {
    const interval = setInterval(() => {
      setActualizado(false)
      actualizarPlayaCalado()
      setUltimaActualizacion(new Date())
    }, INTERVALO_ACTUALIZACION)

    return () => {
      clearInterval(interval)
    }
  }, [actualizarPlayaCalado, setUltimaActualizacion, setActualizado])

  const actualizar = () => {
    setActualizado(false)
    actualizarPlayaCalado()
    setUltimaActualizacion(new Date())
  }

  return (
    <div
      style={{
        border: '2.5px solid rgb(119 119 119)',
        borderRadius: '8px',
        padding: '8px 0px 0 8px'
      }}
    >
      <h5><b>Estado playa calado</b></h5>

      { (camionesCalados && camionesCalados.length > 0) &&
        <ReporteProductosCalado
          callesDeCalado={callesDeCalado}
          calificacionCalles={calificacionCalle}
          camionesCalados={camionesCalados}
          ocupacionCalles={ocupacionCalles}
          soloDetalle
        />
      }

      <div className='container-barchart'>
        {actualizado && (data.length > 0) && (calificacionCalle) && (camionesCalados) &&
          <BarChart
            width={770}
            height={400}
            data={data}
            calificacionCalles={calificacionCalle}
            camionesCalados={camionesCalados}
            xRange={[0, 760]}
            yRange={[300, 0]}
            setCalleDeCalado={() => {}}
          />
        }
        {(!actualizado && (data.length === 0)) && <div className='loader' /> }
      </div>
      <UltimaActualizacionData
        actualizar={actualizar}
        ultimaActualizacion={ultimaActualizacion}
        setUltimaActualizacion={setUltimaActualizacion}
      />
    </div>
  )
}
